module.exports = __webpack_public_path__ + "img/11-3.26811762.jpg";